//SelectUnitDialog
//***********************************************************************************************************************
import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { Translations } from "ui/Scripts/source/models/translations";
import { Dialog, IDialogButton } from "../framework/dialog";
import { IEventCompany, EventCompany } from "../../models/event/eventCompany";
import { IUnitItem, UnitItem } from "../../models/unit/unitItem";
import { DialogButtonType } from "ui/Scripts/source/models/enums";

//TargetCompanyUnitLine
interface ITargetCompanyUnitLine {
    company: IEventCompany;
    unit: IUnitItem;
    isRootUnit: boolean;
    isCompanyLabel: boolean;

    getCompanyId(): string;
    getIdUnit(): string;
    getId(): string;
}

class TargetCompanyUnitLine implements ITargetCompanyUnitLine {
    company: IEventCompany;
    unit: UnitItem;
    isRootUnit: boolean;
    isCompanyLabel: boolean;

    constructor();
    constructor(obj: ITargetCompanyUnitLine);
    constructor(obj?: any) {
        this.company = null;
        this.unit = null;
        this.isRootUnit = obj && obj.isRootUnit || false;
        this.isCompanyLabel = obj && obj.isCompanyLabel || false;
        if (obj && obj.company) {
            this.company = new EventCompany(obj.company);
        }
        if (obj && obj.unit) {
            this.unit = new UnitItem(obj.unit);
        }
    }

    getCompanyId(): string {
        return (!Base.isNullOrUndefined(this.company) ? this.company.id : "");
    }

    getIdUnit(): string {
        return (!Base.isNullOrUndefined(this.unit) ? this.unit.id : "");
    }

    getId(): string {
        return this.getCompanyId() + "_" + this.getIdUnit();
    }

    static createTargetCompanyUnitLine(company: IEventCompany, unit: IUnitItem, isRootUnit: boolean, isCompanyLabel: boolean): TargetCompanyUnitLine {
        const result = new TargetCompanyUnitLine();
        result.company = company;
        result.unit = unit;
        result.isRootUnit = isRootUnit;
        result.isCompanyLabel = isCompanyLabel;
        return result;
    }
}

//EventTargetCompanyListLine
export interface IEventTargetCompanyListLineProp {
    item: ITargetCompanyUnitLine;
    unitsHaveComment: boolean;
    selected: boolean;
    onClick: (companyId: string, unitId: string) => void;
}

export class EventTargetCompanyListLine extends React.Component<IEventTargetCompanyListLineProp, {}> {
    handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.onClick(this.props.item.company.id, !Base.isNullOrUndefined(this.props.item.unit) ? this.props.item.unit.id : null);
    };

    render() {
        const item = this.props.item;
        const hasUnit = !Base.isNullOrUndefined(item.unit);
        const comment = hasUnit && !Base.isNullOrEmpty(item.unit.comment) ? item.unit.comment : "-";
        return (
            <div className={"line" + (this.props.selected ? " selected" : "")} onClick={!item.isCompanyLabel ? this.handleClick : null}>
                <div className="row">
                    <div className={"col col-12"}>
                        <div className="iconCont">
                            {(item.isRootUnit || item.isCompanyLabel) && !Base.isNullOrEmpty(item.company.logo) &&
                                <img alt="..." src={item.company.logo} />
                            }
                            {!(item.isRootUnit || item.isCompanyLabel) &&
                                <span className="icon unit"></span>
                            }
                        </div>
                        <div className="dataCont">
                            {(item.isRootUnit || item.isCompanyLabel) &&
                                <div className="singleLine">{item.company.name}</div>
                            }
                            {hasUnit && !(item.isRootUnit || item.isCompanyLabel) &&
                                <div className={"singleLine" + (this.props.unitsHaveComment ? " sub thin" : "")}>{item.unit.name}</div>
                            }
                            {hasUnit && !(item.isRootUnit || item.isCompanyLabel) && this.props.unitsHaveComment &&
                                <div className="maxTwoLines subsub thin">{comment}</div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

//EventTargetCompanyList
export interface IEventTargetCompanyListProp {
    companies: IEventCompany[];
    units: IUnitItem[];
    companyId: string;
    unitId: string;
    onLineClick: (companyId: string, unitId: string) => void;
}

export class EventTargetCompanyList extends React.Component<IEventTargetCompanyListProp, {}> {
    itemIsSelected = (item: ITargetCompanyUnitLine) => {
        const companyId = item.getCompanyId();
        const index = this.props.companies.findIndex(i => i.id === companyId);
        if (index === 0) {
            return this.props.companyId === companyId && this.props.unitId === item.getIdUnit();
        } else {
            return this.props.companyId === companyId;
        }
    };

    render() {
        const props = this.props;
        const items: TargetCompanyUnitLine[] = [];
        const rootUnit = props.units.find(i => i.isRoot);
        const unitsHaveComment = props.units.findIndex(i => !Base.isNullOrEmpty(i.comment)) > -1;
        if (Base.isNullOrUndefined(rootUnit)) {
            items.push(TargetCompanyUnitLine.createTargetCompanyUnitLine(props.companies[0], null, false, true));
        }
        for (let i = 0; i < props.units.length; i++) {
            items.push(TargetCompanyUnitLine.createTargetCompanyUnitLine(props.companies[0], props.units[i], props.units[i].isRoot, false));
        }
        for (let i = 1; i < props.companies.length; i++) {
            items.push(TargetCompanyUnitLine.createTargetCompanyUnitLine(props.companies[i], null, true, false));
        }
        return (
            <div className="lineContainer companies">
                {items.map(item => (
                    <EventTargetCompanyListLine
                        key={item.getId()}
                        item={item}
                        unitsHaveComment={unitsHaveComment}
                        selected={this.itemIsSelected(item)}
                        onClick={props.onLineClick}
                    />
                ))}
            </div>
        );
    }
}

//SelectReceiverDialog
export interface ISelectReceiverDialogProp {
    classes?: string;
    nextPreviousMode?: boolean;
    companies: IEventCompany[];
    units: IUnitItem[];
    companyId: string;
    unitId: string;
    onOk: (companyId: string, unitId: string) => void;
    onCancel: () => void;
    onPrevious?: () => void;
}

export class SelectReceiverDialog extends React.Component<ISelectReceiverDialogProp, {}> {
    handleCompanyLineClick = (companyId: string, unitId: string) => {
        this.props.onOk(companyId, unitId);
    };

    render() {
        const props = this.props;
        const buttons: IDialogButton[] = [];
        if (props.nextPreviousMode) {
            if (props.onPrevious) {
                buttons.push({ title: Translations.Previous, buttonType: DialogButtonType.Default, onClick: props.onPrevious });
            }
            if (props.onOk) {
                buttons.push({ title: Translations.Next, buttonType: DialogButtonType.Default, onClick: () => { props.onOk(props.companyId, props.unitId); } });
            }
        } else {
            buttons.push({ title: Translations.Cancel, buttonType: DialogButtonType.Default, onClick: props.onCancel });
        }
        const dialogClasses = "selectReceiverDialog" + (!Base.isNullOrEmpty(props.classes) ? " " + props.classes : "");
        return (
            <Dialog
                classes={dialogClasses}
                title={Translations.SelectReceiver}
                body={
                    <div className="largeDialogContent">
                        <EventTargetCompanyList
                            companies={props.companies}
                            units={props.units}
                            companyId={props.companyId}
                            unitId={props.unitId}
                            onLineClick={this.handleCompanyLineClick}
                        />
                    </div>
                }
                buttons={buttons}
                onClose={props.onCancel}/>
        );
    }
}